'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $is_F1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.o)));
}
export { $is_F1 as $is_F1 };
function $isArrayOf_F1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.o)));
}
export { $isArrayOf_F1 as $isArrayOf_F1 };
var $d_F1 = new $j_java$002elang$002e$002dObject.$TypeData().i(1, "scala.Function1", ({
  o: 1
}));
export { $d_F1 as $d_F1 };
